import { registerAuthGuardAddon } from '@erikdakoda/auth-ui/shared/authGuardAddons';
import Notifications from './components/Notifications';
import initI18n from './i18n';

export default function init() {
  initI18n();
  registerAuthGuardAddon(Notifications);
}
